import { HiChevronUp } from "react-icons/hi2";

export function TriangleIcon({ className, color, width, height, ...props }) {
  return (
    <HiChevronUp
      size={width || height || 20}
      color={color}
      className={className}
      {...props}
    />
  );
}
